<template>
  <div
    class="index"
    :style="{ paddingTop: statusBar + 'rem' }"
    ref="menuMorePaddingTop"
  >
    <Header ref="header" title="忘记密码" :back="true" left="" />
    <div class="windowmain">
      <div class="boxmain">
        <div class="boxstep">
          <div class="stepitem stepitemactive" style="flex: 0.7">
            <p class="itemp1">1</p>
            <p class="stepline"></p>
            <p class="itemp2">填写用户名</p>
          </div>
          <div class="stepitem stepitemactive" style="flex: 0.8">
            <p class="itemp1">2</p>
            <p class="stepline2"></p>
            <p class="itemp2">安全验证</p>
          </div>
          <div class="stepitem" style="flex: 0.8">
            <p class="itemp1">3</p>
            <p class="stepline"></p>
            <p class="itemp2">重置密码</p>
          </div>
          <div class="stepitem" style="flex: 0.5">
            <p class="itemp1">4</p>

            <p class="itemp2">完成</p>
          </div>
        </div>
        <div class="v_showdiv"></div>
        <div class="boxinput">
          <p class="boxTitle">安全验证</p>
          <van-form validate-first ref="form1">
            <div class="filed-vertical" v-show="order1">
              <van-radio-group v-model="radio" @change="changRadio">
                <van-radio name="1" icon-size="16" @click="clickRadio">
                  <div class="testtel">
                    <div class="telImg">
                      <img
                        src="@/views/image/userregister/icon_tel.png"
                        alt=""
                      />
                    </div>
                    <div class="teltext">
                      <p class="teltextp1">手机验证</p>
                      <p class="teltextp2">
                        使用账号内已绑定的手机号接收验证码
                      </p>
                    </div>
                  </div>
                </van-radio>
              </van-radio-group>
              <div v-show="radio1">
                <div class="telInput telInput1">
                  <div class="lable">账号绑定的手机号</div>
                  <van-field
                    v-model="telParm.postPhone"
                    class="input"
                    disabled
                    readonly
                    placeholder="请输入姓名"
                  />
                </div>
                <div class="telInput telInput3">
                  <div class="lable">图形验证码</div>
                  <div class="verificationBox" style="position: relative">
                    <van-field
                      v-model="checkCode1"
                      name="checkCode1"
                      clearable
                      :rules="checkCodeRules1"
                      id="verifital_input1"
                      class="input"
                      maxlength="4"
                      placeholder="请输入验证码"
                    ></van-field>

                    <div
                      @click="verificationCode(1)"
                      id="verificationCode1"
                      class="verificationCode"
                    >
                      <div class="codeImg">
                        <img id="code_img1" :src="base64img1" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="telInput telInput3">
                  <div class="lable">手机短信验证码</div>
                  <div class="verificationBox" style="position: relative">
                    <van-field
                      v-model="telParm.phoneNo"
                      name="phoneNo"
                      :rules="phoneNoRules"
                      center
                      clearable
                      maxlength="6"
                      placeholder="请输入验证码"
                    >
                    </van-field>
                    <div id="CodeNuber" class="CodeNuber">
                      <van-button
                        size="small"
                        type="info"
                        :disabled="disabled1"
                        @click="getCode(1)"
                        >{{ CodeNuberName1 }}
                      </van-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="telerr" v-show="isshow1">
                <img
                  src="@/views/image/userregister/icon_er1.png"
                  alt=""
                /><span>账号信息不完整，请选择其他验证方式</span>
              </div>
            </div>
          </van-form>
          <van-form validate-first ref="form2">
            <div class="filed-vertical" v-show="order2">
              <van-radio-group v-model="radio">
                <van-radio name="2" icon-size="16" @click="clickRadio">
                  <div class="testtel">
                    <div class="telImg">
                      <img
                        src="@/views/image/userregister/icon_emil.png"
                        alt=""
                      />
                    </div>
                    <div class="teltext">
                      <p class="teltextp1">邮箱验证</p>
                      <p class="teltextp2">使用账号内的有效邮箱接收验证码</p>
                    </div>
                    <div class="telInput"></div>
                  </div>
                </van-radio>
              </van-radio-group>
              <div v-show="radio2">
                <div class="telInput telInput1">
                  <div class="lable">账号绑定的邮箱</div>
                  <van-field
                    name="postmanEail"
                    v-model="emailParm.postmanEail"
                    class="input"
                    disabled
                    readonly
                    placeholder=""
                  />
                </div>
                <div class="telInput telInput3">
                  <div class="lable">图形验证码</div>
                  <div class="verificationBox" style="position: relative">
                    <van-field
                      name="checkCode2"
                      :rules="checkCodeRules2"
                      v-model="checkCode2"
                      id="verifital_input"
                      class="input"
                      maxlength="4"
                      clearable
                      placeholder="请输入验证码"
                    ></van-field>

                    <div
                      @click="verificationCode(2)"
                      id="verificationCode2"
                      class="verificationCode"
                    >
                      <div class="codeImg">
                        <img id="code_img2" :src="base64img2" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="telInput telInput3">
                  <div class="lable">邮箱验证码</div>
                  <div class="verificationBox" style="position: relative">
                    <van-field
                      name="emailCodeRules"
                      v-model="emailParm.eamilCheck"
                      :rules="emailCodeRules"
                      center
                      clearable
                      maxlength="6"
                      placeholder="请输入验证码"
                    >
                    </van-field>
                    <div id="CodeNuber" class="CodeNuber">
                      <van-button
                        size="small"
                        type="info"
                        :disabled="disabled2"
                        @click="getCode(2)"
                        >{{ CodeNuberName2 }}
                      </van-button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="telerr" v-show="isshow2">
                <img
                  src="@/views/image/userregister/icon_er1.png"
                  alt=""
                /><span>账号信息不完整，请选择其他验证方式</span>
              </div>
            </div>
          </van-form>
          <van-form validate-first ref="form3">
            <div class="filed-vertical" v-show="order3">
              <van-radio-group v-model="radio">
                <van-radio name="3" icon-size="16" @click="clickRadio">
                  <div class="testtel">
                    <div class="telImg">
                      <img
                        src="@/views/image/userregister/icon_numer.png"
                        alt=""
                      />
                    </div>
                    <div class="teltext">
                      <p class="teltextp1">账号信息验证</p>
                      <p class="teltextp2">填写账号所有人相关信息进行验证</p>
                    </div>
                    <div class="telInput"></div>
                  </div>
                </van-radio>
              </van-radio-group>
              <div v-show="radio3">
                <div class="telInput telInput1">
                  <div class="lable">用户名</div>
                  <van-field
                    v-model="account.userName"
                    name="userName"
                    class="input"
                    disabled
                    readonly
                    placeholder="请输入姓名"
                  />
                </div>

                <div class="telInput">
                  <div class="lable"><span>*</span>企业中文名称</div>
                  <van-field
                    v-model="account.etpsNm"
                    class="input"
                    name="etpsNms"
                    :rules="etpsNms"
                    placeholder="请输入企业中文名称"
                  />
                </div>
                <div class="telInput">
                  <div class="lable"><span>*</span>统一社会信用代码</div>
                  <van-field
                    v-model="account.socialCreditCode"
                    class="input"
                    maxlength="18"
                    name="socialCreditCodes"
                    :rules="socialCreditCodes"
                    placeholder="请输入姓名"
                  />
                </div>
                <div class="telInput">
                  <div class="lable"><span>*</span>账号所有人姓名</div>
                  <van-field
                    v-model="account.realName"
                    name="realNames"
                    :rules="realNames"
                    class="input"
                    placeholder="请输入账号所有人姓名"
                  />
                </div>

                <div class="telInput">
                  <div class="lable"><span>*</span>账号所有人证件类型</div>
                  <van-field
                    placeholder="请选择账号所有人证件类型"
                    v-model="account.ieFlag"
                    name="ieFlags"
                    :rules="ieFlags"
                    @click="selectOrginType()"
                    right-icon="arrow"
                    clickable
                    readonly
                  ></van-field>
                </div>

                <div class="telInput">
                  <div class="lable"><span>*</span>账号所有人证件号码</div>
                  <van-field 
                    v-if="orginType=='' || orginType=='01'"
                    v-model="account.idCard"
                    class="input"
                    name="idCards"
                    :rules="idCards"
                    placeholder="请输入账号所有人证件号码"
                  />
                   <van-field 
                    v-else
                    v-model="account.idCard"
                    class="input"
                    name="idCards1"
                    :rules="idCards1"
                    placeholder="请输入账号所有人证件号码"
                  />
                </div>
                <div class="telInput" v-show="orginTypeShow">
                  <div class="lable"><span>*</span>身份证有效起始日期</div>
                  <swSelectDate
                    label="结束时间"
                    id="startDate"
                    name="startDates"
                    :rules="startDates"
                    placeholder="请选择开始日期"
                    v-model="account.startDate"
                    format="yyyyMMdd"
                  />
                </div>
                <div class="telInput" v-show="orginTypeShow">
                  <div class="lable"><span>*</span>身份证有效截止日期</div>
                  <swSelectDate
                    label="结束时间"
                    id="endDate"
                    name="endDates"
                    :rules="endDates"
                    :disabled="isSelect"
                    placeholder="请选择结束日期"
                    v-model="account.endDate"
                    format="yyyyMMdd"
                  />
                  <div class="selectRadio">
                    <van-radio-group v-model="isSelect" @change="changmethod">
                      <van-radio
                        :name="true"
                        icon-size="15px"
                        @click="clickMethod"
                        >长期有效</van-radio
                      >
                    </van-radio-group>
                  </div>
                </div>
                <div class="telInput">
                  <div class="lable"><span>*</span>操作人手机号码</div>
                  <van-field
                    v-model="account.mobile"
                    class="input"
                    name="accountmobiles"
                    :rules="accountmobiles"
                    maxlength="11"
                    placeholder="请输入操作人手机号码"
                  />
                </div>
                <div class="telInput telInput3">
                  <div class="lable"><span>*</span>图形验证码</div>
                  <div class="verificationBox" style="position: relative">
                    <van-field
                      v-model="checkCode3"
                      id="verifital_input"
                      class="input"
                      maxlength="4"
                      name="checkCodes"
                      :rules="checkCodes"
                      clearable
                      placeholder="请输入验证码"
                    ></van-field>

                    <div
                      @click="verificationCode(3)"
                      id="verificationCode3"
                      class="verificationCode"
                    >
                      <div class="codeImg">
                        <img id="code_img3" :src="base64img3" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="telInput telInput3">
                  <div class="lable"><span>*</span>手机短信验证码</div>
                  <div class="verificationBox" style="position: relative">
                    <van-field
                      v-model="account.smsCode"
                      center
                      clearable
                      name="smsCodes"
                      :rules="smsCodes"
                      maxlength="6"
                      placeholder="请输入验证码"
                    >
                    </van-field>
                    <div id="CodeNuber" class="CodeNuber">
                      <van-button
                        size="small"
                        type="info"
                        :disabled="disabled3"
                        @click="getCode(3)"
                        >{{ CodeNuberName3 }}
                      </van-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="telerr" v-show="isshow3">
                <img
                  src="@/views/image/userregister/icon_er1.png"
                  alt=""
                /><span>账号信息不完整，请选择其他验证方式</span>
              </div>
            </div>
          </van-form>
        </div>
      </div>

      <div style="margin: 22px">
        <van-button type="primary" class="btn3" size="large"  @click="blackbtn()">上一步</van-button>
        <van-button
          type="primary"
          class="btn1"
          size="large"
          @click="fromSubmit()"
          >下一步</van-button
        >

        <!-- <van-button
          type="primary"
          class="btn1"
          size="large"
          @click="fromSubmit()"
          >下一步</van-button
        > -->
      </div>
      <!-- 选择器弹出层 -->
      <!-- 原产地证明类型 -->
      <van-popup
        v-model="showOrginType"
        round
        position="bottom"
        get-container="body"
      >
        <van-picker
          show-toolbar
          value-key="codeName"
          :default-index="defaultIndex"
          :ellipsis="false"
          :columns="orginTypeArray"
          @confirm="confirmOrginType"
          @cancel="cancelOrginType"
        ></van-picker>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import swSelectDate from "@/views/components/swSelectDate";
import {
  Form,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Field,
  Col,
  Row,
  Button,
  Picker,
  Popup,
  Icon,
  Step,
  Steps,
  Toast,
  DatetimePicker,
  NoticeBar,
} from "vant";
import { getUUID } from "@/views/components/swDate";
const renderingData = function () {
  const data = JSON.parse(this.resData.res);
  this.certName = this.resData.loginName;
  this.account.userName = this.resData.loginName;
  this.allVerifyTypeVos = data.allVerifyTypeVos;
  this.verifyTypeVos = data.verifyTypeVos;
  for (let i = 0; i < this.allVerifyTypeVos.length; i++) {
    if (this.allVerifyTypeVos[i].order == 1) {
      this.telParm.postPhone = data.mobile;
      this.order1 = true;
    } else if (this.allVerifyTypeVos[i].order == 2) {
      this.order2 = true;
      this.emailParm.postmanEail = data.email;
    } else if (this.allVerifyTypeVos[i].order == 3) {
      this.order3 = true;
    }
  }
  console.log(data);
};
const findMissingElements = function (arr1, arr2) {
  // 比较长度
  if (arr1.length !== arr2.length) {
    return arr1.length > arr2.length
      ? arr1.filter(
          (item) =>
            !arr2.some(
              (arr2Item) => JSON.stringify(arr2Item) === JSON.stringify(item)
            )
        )
      : arr2.filter(
          (item) =>
            !arr1.some(
              (arr1Item) => JSON.stringify(arr1Item) === JSON.stringify(item)
            )
        );
  }

  // 逐元素比较
  let missingElements = [];
  for (let i = 0; i < arr1.length; i++) {
    // 检查每个对象的所有属性
    const keys1 = Object.keys(arr1[i]);
    const keys2 = Object.keys(arr2[i]);

    if (keys1.length !== keys2.length) {
      missingElements.push(arr1[i]);
    } else {
      for (let key of keys1) {
        if (arr1[i][key] !== arr2[i][key]) {
          missingElements.push(arr1[i]);
          break;
        }
      }
    }
  }

  return missingElements;
};
const getVerificationCode = function () {
  this.$http
    .get("/nuserwebserver/forget/password/img?captchaKey=" + getUUID())
    .then((res) => {
      this.pacClientId1 = res.data.captchaKey;
      this.base64img1 = res.data.img;
      this.checkCode1 = "";
    })
    .catch((err) => {
      console.warn(err);
      this.$toast("查询失败，请稍后重试");
    });
};
const getVerificationemail = function () {
  this.$http
    .get("/nuserwebserver/forget/password/img?captchaKey=" + getUUID())
    .then((res) => {
      this.pacClientId2 = res.data.captchaKey;
      this.base64img2 = res.data.img;
      this.checkCode2 = "";
    })
    .catch((err) => {
      console.warn(err);
      this.$toast("查询失败，请稍后重试");
    });
};
const getVerificationidDoc = function () {
  this.$http
    .get("/nuserwebserver/forget/password/img?captchaKey=" + getUUID())
    .then((res) => {
      this.pacClientId3 = res.data.captchaKey;
      this.base64img3 = res.data.img;
      this.checkCode3 = "";
    })
    .catch((err) => {
      console.warn(err);
      this.$toast("查询失败，请稍后重试");
    });
};
const getiddoctype = function () {
  var _this = this;
  this.$http
    .get("/nuserwebserver/param/identity", {
      unLoading: true,
    })
    .then((res) => {
      if (res.code == "0") {
        let dataList = res.data;

        for (let i = 0; i < dataList.length; i++) {
          _this.orginTypeArray.push(dataList[i].desc);
          _this.orginTypeData.push({
            codeName: dataList[i].desc,
            codeValue: dataList[i].type,
          });
        }
        // $.map(dataList, function (val, index) {
        //   _this.orginTypeArray.push(val);
        //   console.log(index);
        //   _this.orginTypeData.push({ codeName: val, codeValue: index });
        // });
        console.log(this.orginTypeData);
      } else {
        this.$toast(res.msg);
      }
    })
    .catch(() => {
      this.$toast("查询失败，请稍后重试");
      // this.GM.BiHint('查询失败，请稍后重试');
    });
};
//触发类型弹出
const selectOrginType = function () {
  this.showOrginType = true;
};
//类型取消事件
const cancelOrginType = function () {
  this.showOrginType = false;
};
//确认事件
const confirmOrginType = function (value) {
  this.account.ieFlag = value;
  for (let i = 0; i < this.orginTypeData.length; i++) {
    const temp = this.orginTypeData[i];
    if (temp.codeName === value) {
      this.orginType = temp.codeValue;
      console.log(this.orginType, this.account.ieFlag);
      if (this.orginType == "01") {
        this.orginTypeShow = true;
      } else {
        this.orginTypeShow = false;
      }
      break;
    }
  }
  this.showOrginType = false;
};
export default {
  name: "swforgotpsdIndex",
  data() {
    return {
      certName: "",
      certpsd: "",
      cerpsed: "",
      certNo: "",
      allVerifyTypeVos: [],
      verifyTypeVos: [],
      order1: false,
      order2: false,
      order3: false,
      radio3: false,
      orginType:'',
      radio2: false,
      radio1: false,
      orginTypeShow: true,
      orginTypeShow1: false,
      emailParm: {
        postmanEail: "",
        eamilCheck: "",
      },
      telParm: {
        postPhone: "",
        phoneNo: "",
      },
      account: {
        userName: "",
        startDate: "",
        endDate: "",
        ieFlag: "",
        etpsNm: "",
        socialCreditCode: "",
        realName: "",
        idCard: "",
        mobile: "",
        smsCode: "",
      },
      defaultIndex: 0,

      isSelect: false,
      ischange: false,
      disabled1: false,
      disabled2: false,
      disabled: false,
         disabled3: false,
      showOrginType: false,
      CodeNuberName: "获取验证码",
      CodeNuberName1: "获取验证码",
      CodeNuberName2: "获取验证码",
      CodeNuberName3: "获取验证码",
      base64img1: "",
      base64img2: "",
      base64img3: "",
      pacClientId1: "",
      pacClientId2: "",
      pacClientId3: "",
      downIcon: true,
      headerShow: true,
      downIcon1: true,
      isshow1: false,
      isshow2: false,
      isshow3: false,
      isshowTxt1: false,
      isshowTxt2: false,
      isshowTxt3: false,
      phoneNo: "",
      codeName: "",
      checkCode1: "",
      checkCode2: "",
      checkCode3: "",
      orginTypeArray: [],
      orginTypeData: [
        // { codeName: "进境", codeValue: "I" },
        // { codeName: "出境", codeValue: "E" },
      ],
      etpsNms: [
        {
          required: true,

          message: "请输入企业中文名称",
          trigger: "onBlur",
        },
        {
          validator: (value) => {
            return /^[A-Za-z\u4e00-\u9fa5\d·.、（）()/-_——''"";:；“”_&,:：，]{2,256}$/.test(
              value
            );
          },
          message: "可录入中文、数字、英文或部分符号（例如括号）,长度是2-256位",
          trigger: "onBlur",
        },
        {
          pattern: /^.{2,256}$/,

          message: "长度是2-256位",
          trigger: "onBlur",
        },
      ],
      socialCreditCodes: [
        {
          required: true,

          message: "请输入统一社会信用代码",
          trigger: "onBlur",
        },

        {
          validator: (value) => {
            return /^[0-9a-hj-np-rt-uw-yA-HJ-NP-RT-UW-Y]{18}$/.test(value);
          },
          message: "只可录入英文或数字(禁止录入 I、O、Z、S、V),长度是18位",
          trigger: "onBlur",
        },
        {
          pattern: /^.{18}$/,

          message: "长度是18位",
          trigger: "onBlur",
        },
      ],
      realNames: [
        {
          required: true,

          message: "请输入账号所有人姓名",
          trigger: "onBlur",
        },

        {
          validator: (value) => {
            const pattern = /[!#$%^*{}\\[\]:<>?|~]/im;
            return !pattern.test(value);
          },
          message: "姓名不能含有 !#$%^*{}[]:<>?|~ 字符",
          trigger: "onBlur",
        },
        {
          pattern: /^.{2,149}$/,

          message: "长度是2-149位",
          trigger: "onBlur",
        },
      ],
      ieFlags: [
        {
          required: true,

          message: "请选择账号所有人证件类型",
          trigger: "onBlur",
        },
      ],
      checkCodeRules1: [
        {
          required: true,

          message: "请输入图形验证码",
          trigger: "onBlur",
        },
        // {
        //   validator: (value) => {
        //     return /^[0-9a-zA-Z][a-z]{4}$/.test(value);
        //   },
        //   message: "验证码为4位数字或英文",
        //   trigger: "onBlur",
        // },
      ],
      idCards: [
        {
          required: true,

          message: "请输入账号所有人证件号码",
          trigger: "onBlur",
        },

        {
          validator: (value) => {
            return /(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value);
          },
          message: "证件号只允许有一个字母 X,并在最后一位,且长度是18位",
          trigger: "onBlur",
        },
        {
          pattern: /^.{18}$/,

          message: "长度是18位",
          trigger: "onBlur",
        },
      ],
       idCards1: [
        {
          required: true,

          message: "请输入账号所有人证件号码",
          trigger: "onBlur",
        },

        {
          validator: (value) => {
            return /^[0-9a-zA-Z]{4,64}$/.test(value);
          },
          message: "只可录入英文字母及数字,证件号长度最小4位最长64位",
          trigger: "onBlur",
        },
        {
          pattern: /^.{18}$/,

          message: "证件号长度最小4位最长64位",
          trigger: "onBlur",
        },
      ],
      startDates: [
        {
          required: false,

          message: "请选择开始日期",
          trigger: "onBlur",
        },
      ],
      endDates: [
        {
          required: false,

          message: "请选择结束日期",
          trigger: "onBlur",
        },
      ],
      accountmobiles: [
        {
          required: true,

          message: "请输入操作人手机号码",
          trigger: "onBlur",
        },
        {
          validator: (value) => {
            return /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])||([9][0-3,5-9]))[0-9]{8}$/.test(
              value
            );
          },
          message: "手机号格式错误",
          trigger: "onBlur",
        },
        {
          pattern: /^.{11}$/,

          message: "长度是11位",
          trigger: "onBlur",
        },
      ],
      checkCodes: [
        {
          required: true,

          message: "请输入图形验证码",
          trigger: "onBlur",
        },
      ],
      smsCodes: [
        {
          required: true,

          message: "请输入手机短信验证码",
          trigger: "onBlur",
        },
      ],
      checkCodeRules2: [
        {
          required: true,

          message: "请输入图形验证码",
          trigger: "onBlur",
        },
        // {
        //   validator: (value) => {
        //     return /^[0-9a-zA-Z][a-z]{4}$/.test(value);
        //   },
        //   message: "验证码为4位数字或英文",
        //   trigger: "onBlur",
        // },
      ],
      checkCodeRules3: [
        {
          required: true,

          message: "请输入图形验证码",
          trigger: "onBlur",
        },
        // {
        //   validator: (value) => {
        //     return /^[0-9a-zA-Z][a-z]{4}$/.test(value);
        //   },
        //   message: "验证码为4位数字或英文",
        //   trigger: "onBlur",
        // },
      ],
      phoneNoRules: [
        {
          required: true,

          message: "请输入手机验证码",
          trigger: "onBlur",
        },
      ],
      emailCodeRules: [
        {
          required: true,

          message: "请输入验证码",
          trigger: "onBlur",
        },
      ],
      resData: this.$route.query, //获取查询页面传参
      passdType: "password",
      radio: "",
      checkRadioFlag: false,

      model: {
        param: {
          seqNo: "",
          billType: "23003",
          projectSubCode: "2",
          status: "",
          pageSize: 10,
          pageNum: 0,
          businessNo: "",
          businessNo1: "",
          carNo: "",
          declareName: "",
          startDate: "",
          endDate: "",
        },
      },
      view: {
        searchForm: {
          seqNo: "",
          status: "",
          statusName: "所有状态",
          businessNo: "",
          businessNo1: "",
          carNo: "",
          declareName: "",
          startDate: "",
          endDate: "",
        },
        statusList: [],
      },
      bizCode: "FACE_ALIPAY_SDK",
      statusBar: 0,
      value: "",
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
    this.getVerificationCode();
    this.getiddoctype();
  },
  watch: {
    active() {
      if (this.active == 2) {
        //console.log("===============");
        // window.scrollTo({
        //   top: 300,
        // });
      }
    },
    //路由回调刷新
    statusBar() {
      this.headerShow = false;
      this.$nextTick(function () {
        this.statusBar = this.$tool.statusBar(44);
        this.headerShow = true;
        //console.log(sessionStorage.getItem("statusBar") + "bbbbccc ");
      });
    },
  },
  methods: {
    renderingData,
    findMissingElements,
    getiddoctype,
    getVerificationemail,
    getVerificationidDoc,
    blackbtn(){
       this.$router.go(-1)
    },
    changmethod() {
      this.ischange = true;
      console.log(1);
    },
    changRadio() {
      this.checkRadioFlag = false;
    },
    clickRadio() {
      // 调用函数
      let result = findMissingElements(
        this.allVerifyTypeVos,
        this.verifyTypeVos
      );

      // 输出结果
      for (let k = 0; k < result.length; k++) {
        if (result[k].order == 1) {
          this.isshowTxt1 = true;
        } else if (result[k].order == 2) {
          this.isshowTxt2 = true;
        } else if (result[k].order == 3) {
          this.isshowTxt3 = true;
        }
      }
      // if (result.length > 0) {
      //     console.log("缺少的元素：");
      //     result.forEach(item => {
      //         console.log(item);

      //     });
      // } else {
      //     console.log("两个数组对象完全相同。");
      // }

      if (this.radio == "1") {
        if (this.isshowTxt1) {
          this.isshow1 = true;
          this.radio2 = false;
          this.radio3 = false;
        } else {
           this.getVerificationCode();
          this.radio1 = true;
          this.radio2 = false;
          this.radio3 = false;
          this.isshow2 = false;
          this.isshow3 = false;
        }
      } else if (this.radio == "2") {
        if (this.isshowTxt2) {
          this.isshow2 = true;
          this.radio1 = false;
          this.radio3 = false;
        } else {
          this.getVerificationemail();
          this.isshow1 = false;

          this.isshow3 = false;
          this.radio2 = true;

          this.radio1 = false;
          this.radio3 = false;
        }
      } else if (this.radio == "3") {
        if (this.isshowTxt3) {
          this.isshow3 = true;
          this.radio2 = false;

          this.radio1 = false;
        } else {
          this.getVerificationidDoc();
          this.isshow1 = false;
          this.isshow2 = false;
          this.radio3 = true;
          this.radio2 = false;

          this.radio1 = false;
        }
      }
      // if(this.checkRadioFlag){

      // }
      this.checkRadioFlag = true;
      // this.$toast("查询失败1");
    },
    clickMethod() {
      this.isSelect = this.ischange ? this.isSelect : !this.isSelect;
      this.ischange = false;
      if (this.isSelect) {
        this.account.endDate = "长期有效";
      } else {
        this.account.endDate = "";
      }
    },
    //手机号验证
    verifymobile() {
      let params = {
        loginName: this.certName,
        verifyCode: this.telParm.phoneNo,
      };
      this.$http
        .post("/nuserwebserver/forget/password/verify/mobile", params)
        .then((res) => {
          if (res.code == "0") {
         
            // this.$router.push({
            //   path: "/swforgotverify",
            //   query: {
            //     res:JSON.stringify( res.data),
            //     loginName: this.certName,
            //   },
            // });
          } else {
            this.checkCode1 = "";
            this.telParm.phoneNo = "";
            this.getVerificationCode();
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          this.$toast("查询失败");
        });
    },
    //邮箱验证
    verifyemail() {
      let params = {
        loginName: this.certName,
        verifyCode: this.emailParm.eamilCheck,
      };
      this.$http
        .post("/nuserwebserver/forget/password/verify/email", params)
        .then((res) => {
          if (res.code == "0") {
            console.log(11111);
            // this.$router.push({
            //   path: "/swforgotverify",
            //   query: {
            //     res:JSON.stringify( res.data),
            //     loginName: this.certName,
            //   },
            // });
          } else {
            this.checkCode2 = "";
            this.emailParm.eamilCheck = "";
            this.getVerificationemail();
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          this.$toast("查询失败");
        });
    },
    // 账号信息验证
    verifyIdDoc(){
      //    account: {
      //   userName: "",
      //   startDate: "",
      //   endDate: "",
      //   ieFlag: "",
      //   etpsNm: "",
      //   socialCreditCode: "",
      //   realName: "",
      //   idCard: "",
      //   mobile: "",
      //   smsCode: "",
      // },

   let params = {
        captchaKey: this.pacClientId3 ,
        captchaValue:this.checkCode3,
      
        etpsNm:  this.account.etpsNm,
        //   effDate: this.account.startDate,
        // expDate:this.account.endDate,
        idCardNum:this.account.idCard,
        idCardType:this.orginType,
        loginName: this.certName,
        phoneNo: this.account.mobile,
        realName: this.account.realName,
        socialCreditCode: this.account.socialCreditCode,
        verifyCode: this.account.smsCode,
      };
      if(this.orginType=='01'){
        params.effDate=  this.account.startDate;
        if(this.account.endDate == '长期有效'){
          this.account.endDate='00000000'
        }
        params.expDate= this.account.endDate;
      }
      this.$http
        .post("/nuserwebserver/forget/password/verify/idDoc", params)
        .then((res) => {
          if (res.code == "0") {
            console.log(11111);
            // this.$router.push({
            //   path: "/swforgotverify",
            //   query: {
            //     res:JSON.stringify( res.data),
            //     loginName: this.certName,
            //   },
            // });
          } else {
            this.checkCode2 = "";
            this.emailParm.eamilCheck = "";
            this.getVerificationemail();
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          this.$toast("查询失败");
        });
    },
    fromSubmit() {
      if (this.radio1) {
        this.$refs.form1
          .validate()
          .then(() => {
            if (this.isshow1) {
              this.$toast("请选择其他验证方式");
              return false;
            }
            this.verifymobile();
          })
          .catch(() => {});
      } else if (this.radio2) {
        this.$refs.form2
          .validate()
          .then(() => {
            if (this.isshow2) {
              this.$toast("请选择其他验证方式");
              return false;
            }
            this.verifyemail();
          })
          .catch(() => {});
      } else if (this.radio3) {
        if (this.orginTypeShow) {
          this.startDates[0].required = true;
          this.endDates[0].required = true;
        }
        this.$refs.form3
          .validate()
          .then(() => {
            if (this.isshow3) {
              this.$toast("请选择其他验证方式");
              return false;
            }
             this.verifyIdDoc()
          })
          .catch(() => {});
      } else {
        this.$toast("请先选择验证方式");
      }
      // this.$router.push({
      //     path: '/swforgotpsd',

      //   });
    },
    selectOrginType,
    confirmOrginType,
    cancelOrginType,
    getVerificationCode,
    verificationCode: function (val) {
      //  重新点击验证码
      if(val ==1){
      this.getVerificationCode();
      this.checkCode1 = "";
      }else if(val ==2){
 this.getVerificationemail();
      this.checkCode2 = "";
      }else if(val ==3){
         this.getVerificationidDoc();
      this.checkCode3 = "";
      }
    
    },
    //获取验证码
    getCode: function (val) {
      if (val == 1) {
        if (this.checkCode1.trim().length == 0) {
          this.$toast("请先填写图片验证码");
          return;
        }
        let params = {
          captchaKey: this.pacClientId1,
          captchaValue: this.checkCode1,
          loginName: this.certName,
        };

        this.disabled1 = true;
        this.$http
          .post("/nuserwebserver/forget/password/send/mobile", params)
          .then((res) => {
            if (res.code == "0") {
              this.$toast("验证码发送成功");
              let that = this;
              let time = 60;
              let timer = setInterval(function () {
                if (time == 0) {
                  clearInterval(timer);
                  that.disabled1 = false;
                  that.CodeNuberName1 = "重新获取";
                } else {
                  that.disabled1 = true;
                  that.CodeNuberName1 = time + "秒";
                  time--;
                }
              }, 1000);
            } else {
              this.disabled1 = false;
              this.$toast(res.msg);
            }
          })
          .catch(() => {
            this.$toast("查询失败");
          });
      } else if (val == 2) {
        if (this.checkCode2.trim().length == 0) {
          this.$toast("请先填写图片验证码");
          return;
        }
        let params = {
          captchaKey: this.pacClientId2,
          captchaValue: this.checkCode2,
          loginName: this.certName,
        };

        this.disabled2 = true;
        this.$http
          .post("/nuserwebserver/forget/password/send/email", params)
          .then((res) => {
            if (res.code == "0") {
              this.$toast("验证码发送成功");
              let that = this;
              let time = 60;
              let timer = setInterval(function () {
                if (time == 0) {
                  clearInterval(timer);
                  that.disabled2 = false;
                  that.CodeNuberName2 = "重新获取";
                } else {
                  that.disabled2 = true;
                  that.CodeNuberName2 = time + "秒";
                  time--;
                }
              }, 1000);
            } else {
              this.disabled2 = false;
              this.$toast(res.msg);
            }
          })
          .catch(() => {
            this.$toast("查询失败");
          });
      } else if (val == 3) {
        if (this.account.mobile.trim().length == 0) {
          this.$toast("请先填写手机号码");
          return;
        }
        if (this.checkCode3.trim().length == 0) {
          this.$toast("请先填写图片验证码");
          return;
        }
        let params = {
          captchaKey: this.pacClientId3,
          captchaValue: this.checkCode3,
          loginName: this.certName,

          phoneNo: this.account.mobile,
        };

        this.disabled3 = true;
        this.$http
          .post("/nuserwebserver/forget/password/verify/idDoc/mobile", params)
          .then((res) => {
            if (res.code == "0") {
              this.$toast("验证码发送成功");
              let that = this;
              let time = 60;
              let timer = setInterval(function () {
                if (time == 0) {
                  clearInterval(timer);
                  that.disabled3 = false;
                  that.CodeNuberName3 = "重新获取";
                } else {
                  that.disabled3 = true;
                  that.CodeNuberName3 = time + "秒";
                  time--;
                }
              }, 1000);
            } else {
              this.disabled3 = false;
              this.$toast(res.msg);
            }
          })
          .catch(() => {
            this.$toast("查询失败");
          });
      }
    },
  },
  created() {
    this.renderingData();
  },
  components: {
    Header,
    swSelectDate,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [NoticeBar.name]: NoticeBar,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Icon.name]: Icon,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/public.scss";
@import "@/views/css/userindex.scss";
// ::v-deep .van-cell {
//   display: block;
// }
// ::v-deep .van-cell::after {
//   border-bottom: 0px;
// }
::v-deep .van-overflow-hidden {
  overflow: visible !important;
  overflow-x: visible !important;
  overflow-y: visible !important;
}
.windowmain {
  width: 100%;
  padding-bottom: 40px;

  .boxmain {
    width: 100%;
    .boxTitle {
      font-size: 13px;
      color: #333;
      font-weight: bold;
      margin-bottom: 14px;
    }
    .boxstep {
      width: auto;
      background: #fff;
      height: auto;
      display: flex;
      padding: 14px 11px 16px 11px;
      .stepitem {
        flex: 1;
        position: relative;
        text-align: center;
        .stepline {
          position: absolute;
          width: 42px;
          height: 1px;
          background: #d5d5d5;
          left: 70px;
          top: 9px;
        }
        .stepline2 {
          position: absolute;
          width: 50px;
          height: 1px;
          background: #d5d5d5;
          left: 76px;
          top: 9px;
        }
        .itemp1 {
          width: 17px;
          height: 17px;
          background: #d5d5d5;
          font-size: 11px;
          color: #fff;
          text-align: center;
          border-radius: 50%;
          line-height: 18px;
          display: block;
          position: relative;
          margin: 0 auto;
        }
        .itemp2 {
          font-size: 12px;
          color: #999;
          margin-top: 6px;
        }
      }
      .stepitemactive {
        .itemp1 {
          background: #00599c;
        }
        .itemp2 {
          color: #00599c;
        }
        .stepline {
          background: #00599c;
        }
      }
    }
  }
  .CodeNuber {
    position: absolute;
    right: 0.106667rem;
    width: 2.4rem;
    height: 0.933333rem;
    top: 7px;
  }
  .van-button--small {
    width: 87px;
    padding: 0px;
    background: #00599c;
    border: 1px solid #00599c;
  }
  .boxinput {
    height: auto;
    border-radius: 4px;
    background: #fff;
    padding: 10px 20px;

    .filed-vertical {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      margin-bottom: 8px;
      border: 1px solid #ddd;
      box-shadow: 1px 3px 3px 0px #f1f1f1;
      border-radius: 4px;
      padding: 14px 10px;
      .telerr {
        margin-top: 10px;
        height: 24px;
        border: 1px solid #ecd1c2;
        border-radius: 3px;
        font-size: 11px;
        line-height: 24px;
        color: #cc0000;
        background: rgb(246, 233, 226);
        img {
          width: 11px;
          height: 11px;
          margin: 0 10px;
        }
      }
      .testtel {
        width: 100%;
        display: flex;
        .telImg {
          height: 30px;
          width: auto;
          margin: 4px;
          img {
            height: 30px;
          }
        }
        .teltext {
          width: auto;
          margin-left: 16px;
          .teltextp1 {
            font-size: 12px;
            color: #00599c;
          }
          .teltextp2 {
            font-size: 11px;
            color: #999;
          }
        }
      }
      .lable {
        font-size: 12px;
        color: #333;
      }
      .lable span {
        display: inline-block;
        color: #ee0a24;
        margin-right: 4px;
      }
      ::v-deep.van-cell {
        padding: 0px;
      }
      ::v-deep .van-cell .van-field__body {
        border: 1px solid #ddd;
        padding: 4px 9px;
        border-radius: 4px;
        margin-top: 6px;
      }
      ::v-deep .van-cell .van-field__body:hover {
        border: 1px solid #00599c;
        box-shadow: 0px 2px 5px 3px raga(0, 89, 156, 0.1);
      }
      .telInput {
        margin-top: 8px;
        margin-left: 9%;
      }
      ::v-deep .telInput1 .van-cell .van-field__body {
        border: 1px solid #ddd;
        padding: 4px 9px;
        background: #efefef;
        border-radius: 4px;
        margin-top: 4px;
      }
      // ::v-deep .van-field__control:focus{
      //   border: 1px solid #00599c;
      //   box-shadow:  0px 2px 5px 3px raga(0,89,156,0.10);
      // }
    }
  }
  ::v-deep .van-cell::after {
    border-bottom: 0px solid #ddd;
  }
  .v_showdiv {
    height: 12px;
    background: #f7f8fa;
  }
  .selectRadio {
    margin-top: 5px;
    width: 100%;
    .van-radio-group {
      width: auto;
      float: right;
    }
  }
  .telInput3 .van-cell {
    width: 64%;
  }
  .verificationCode {
    top: 7px;
  }
  .verificationCode .codeImg {
    width: 88px;
    height: 32px;
  }
  ::v-deep .van-radio__label {
    width: 100%;
  }
  html,
  body {
    overflow: visible;
    -webkit-overflow-scrolling: touch;
    position: relative !important;
  }
  ::v-deep #endDate .van-field--disabled .van-field__body {
    background: #efefef;
    border: 1px solid #ddd;
  }
  .ftBton {
    padding: 0px 15px;
    font-size: 11px;
    color: #999;
  }
}
</style>